import { range } from 'lodash';
import * as ToastsSelectors from '../../selectors/toasts';
import * as SettingsSelectors from '../../selectors/settings';
import * as NotificationsSelectors from '../../selectors/notifications';
import * as ToastsActions from '../toasts';
import * as QueueActions from '../queue';
import { MAX_TOAST_COUNT } from '../../../../../shared/constants';
import { ADD, REMOVE } from './types';

export const handleNewNotification =
    (notification) =>
    (dispatch, getState, { tabManager }) => {
        if (notification.disableToast) {
            return;
        }

        const state = getState();
        dispatch(addNotification(notification));

        if (SettingsSelectors.isSoundEnabled(state)) {
            tabManager.playSound();
        }

        if (NotificationsSelectors.isExists(state, notification.id)) {
            return;
        }

        const shouldEmitNotification = tabManager.isFocused() && !ToastsSelectors.isFull(state);

        dispatch(QueueActions.enqueue(notification));

        if (shouldEmitNotification) {
            dispatch(ToastsActions.emit());
        }
    };

export function addNotification(notification) {
    return {
        type: ADD,
        payload: notification,
    };
}

export const emitNotifications = () => (dispatch) => {
    range(MAX_TOAST_COUNT).forEach(() => {
        dispatch(ToastsActions.emit());
    });
};

export const markNotificationConsumed = (notificationId) => (dispatch) => {
    dispatch(QueueActions.remove(notificationId));
};

export function removeNotification(notification) {
    return {
        type: REMOVE,
        payload: notification,
    };
}
